import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import HourConfig from './HourConfigs';
import CSVColConfigs from './CSVColConfigs';
import EmailSender from './EmailSender';

class Config extends Component {
  state = {
    servertTime: '',
    nextDayTime: '',
    configs: {},
  };

  componentDidMount() {
    axios
      .get('/api/v1/configs')
      .then(resp => resp.data)
      .then(data => {
        delete data.success;
        data.servertTime = moment(data.servertTime).toString();
        this.setState(data);
      })
      .catch(e => {
        toast.error(`Impossible d'obtenir les configurations`);
      });
  }

  render() {
    const { servertTime, configs, nextDayTime } = this.state;
    return (
      <React.Fragment>
        <div className="col-md-12">
          <HourConfig servertTime={servertTime} nextDayTime={nextDayTime} />
        </div>
        <div className="col-md-12">
          <CSVColConfigs inputs={configs} />
        </div>
        <div className="col-md-12 email">
          <EmailSender />
        </div>
      </React.Fragment>
    );
  }
}

export default Config;
